import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        return next.handle(request).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {                    
                    if (event.body && event.body.statusCode === 401) {
                        this.router.navigate(['/account/login', { message: event.body.messageCode }])
                    }
                }
            }),
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401) {
                    this.authenticationService.logout();
                    this.router.navigate(['/login', { statusCode: '401' }])
                }
                const error = err.error?.message || err.statusText;
                return throwError(() => error);
            })
        );
    }
}
